<template>
  <div class="products-filter" role="dialog" aria-labelledby="productsFilterTitle" aria-modal="true">
    <div class="bg" v-on:click.prevent="close"></div>
    <div class="content">
      <CloseButton ref="closeButton" @close="close" />
      <h3 id="productsFilterTitle">Produkte filtern</h3>
      <ul>
        <li v-for="filter in categories" :key="filter.slug" :class="{ checked: thisFilters.indexOf(filter.title) >= 0 }">
          <label
            :for="filter.id"
            :class="{ checked: thisFilters.indexOf(filter.title) >= 0 }"
            ><i :class="`${filter.class}`"></i><span>{{ filter.title }}</span>
            <div class="input-wrapper">
              <input
                type="checkbox"
                v-model="thisFilters"
                :id="filter.slug"
                :value="filter.title"
                role="checkbox"
                :aria-checked="thisFilters.indexOf(filter.title) >= 0"
                :aria-label="`${filter.title} auswählen`"
              ></div
          ></label>
        </li>
        <li>
          <label
            for="video"
            :class="{ checked: thisFilters.indexOf('video') >= 0 }"
          >
            <i class="icon-video" aria-hidden="true"></i><span>Mit Produktvideo</span>
            <div class="input-wrapper">
              <input
                type="checkbox"
                v-model="thisFilters"
                id="video"
                value="video"
              >
            </div>
          </label>
        </li>
      </ul>
      <button class="button-light reset" v-on:click.prevent="reset">
        Filter zurücksetzen
      </button>
      <button class="button-primary" v-on:click.prevent="close">
        {{ products.length }}
        {{
          `${products.length > 1 ? "Produkte anzeigen" : "Produkt anzeigen"}`
        }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import CloseButton from "@/components/CloseButton.vue";
import debounce from "lodash.debounce";

export default {
  name: "filters-component",
  components: { CloseButton },
  data() {
    return {
      thisFilters: []
    };
  },
  mounted() {
    this.thisFilters = this.filters.slice();
    this.$refs.closeButton && this.$refs.closeButton.$el.focus();
    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.close();
      }
    });
  },
  methods: {
    reset() {
      this.thisFilters = [];
      this.$store.commit("SET_FILTERS");
    },
    close() {
      this.$emit("close");
    },
    setStateFilters: debounce(function() {
      this.$store.commit("SET_FILTERS", this.thisFilters);
    }, 500)
  },
  watch: {
    thisFilters(newVal) {
      this.setStateFilters(newVal);
    }
  },
  computed: {
    ...mapGetters(["products"]),
    ...mapState(["categories", "filters"])
  }
};
</script>

<style lang="scss">
@import "./Filter";
</style>
